import campaignsGetter from './getters'
import campaignsMutation from './mutations'
import campaignsActions from './actions'

export default {
  namespaced: true,
  state() {
    return {
      campaigns: [],
    }
  },
  getters: campaignsGetter,
  mutations: campaignsMutation,
  actions: campaignsActions,
}
